export interface FoundationLevelCla {
  foundationLevelCla: boolean;
}
